module.exports = __webpack_public_path__ + "img/title_2.d8e93b70.png";